import { subscript as subscript_1 } from './subscript.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';

import { toggleSubscript } from 'roosterjs-editor-api';

const subscript: RibbonButton = {
    key: 'subscript',
    title: () => loc(subscript_1),
    imageSrc: require('../svg/subscript.svg'),
    buttonState: formatState =>
        formatState.isSubscript ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: plugin => toggleSubscript(plugin.getEditor()),
};

export default subscript;
